export const calendarQueryKeys = () => ["home", "calendar"]
